module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/patient_recommends/img_avatar_04-252e42a41208844a16f8bf1a3d99d418.png";